import { render, staticRenderFns } from "./ProjectSupplierSelector.vue?vue&type=template&id=63575f0c&scoped=true&"
import script from "./ProjectSupplierSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectSupplierSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSupplierSelector.vue?vue&type=style&index=0&id=63575f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63575f0c",
  null
  
)

export default component.exports